import type { IRentalProtectionDisclaimersModel, IStyledTextDescriptionModel, IStyledTextModel } from './Types';

export default (rentalProtectionDisclaimers: IRentalProtectionDisclaimersModel) => {
  const { disclaimers } = rentalProtectionDisclaimers;
  const disclaimersList = disclaimers.map((styledText: IStyledTextModel) => {
    return StyledTextModel(styledText);
  });
  return {
    disclaimers: disclaimersList,
  };
};

const DescriptionListModel = (descriptionList: Array<IStyledTextDescriptionModel>) => {
  return descriptionList.map((description: IStyledTextDescriptionModel) => {
    return {
      text: description.text && String(description.text),
      url: description.url && String(description.url),
      stylings: description.stylings && Array(description.stylings),
    };
  });
};

const StyledTextModel = (styledText: IStyledTextModel) => {
  const { header = '', description = [] } = styledText;

  return {
    header: header && String(header),
    description: DescriptionListModel(description),
  };
};
